import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss'],
})
export class WishlistComponent implements OnInit {
  token: any;
  clientID: any;
  items: any[] = [];

  constructor(private rest: RestService, private router: Router) {}

  ngOnInit() {
    this.token = localStorage.getItem('token');
    this.clientID = localStorage.getItem('clientID');
    this.loadWishlist();
  }

  loadWishlist() {
    this.rest.getWishlist(this.clientID, this.token).subscribe((res: any) => {
      this.items = (res || []).map((item: any) => {
        if (item.product?.images?.length > 0) {
          item.product.images[0].image_url = `${environment.apiUrl}/images/?id=${item.product.images[0].image_url}`;
        }
        return item;
      });
      this.rest.sendWishlistCount(this.items.length);
    });
  }

  remove(productId: any) {
    this.rest.removeFromWishlist(this.clientID, productId, this.token).subscribe(() => {
      this.rest.successToast('toast.wishlist_removed');
      this.loadWishlist();
    });
  }

  effectivePrice(product: any): number {
    if (!product?.discount || product.discount <= 0) return product?.price;
    return Math.round(product.price * (100 - product.discount) / 100);
  }

  goToProduct(productId: any) {
    this.router.navigateByUrl(`/products_details/${productId}`);
  }
}
